import React, { useCallback } from 'react';

import { farmsRoute } from '~/routes'
import CrudLayoutList from '~/containers/CrudLayoutList';
import farmSchema from '~/records/schema/farmSchema';
import { useDispatch, connect } from 'react-redux';
import { fetchRecords, destroyRecord } from '~/store/modules/farms';

function List({isLoading, rows, total}) {
  const dispatch = useDispatch();

  const handleFetch = useCallback(
    async (params, requestSource) => {
      dispatch( fetchRecords(params, requestSource) )
    },
    [],
  )

  const onDelete = useCallback(
    async (row) => {
      dispatch( destroyRecord(row.id) )
    },
    []
  )

  return (
    <CrudLayoutList
      breadcrumbs={[{ text: 'Fazendas' }]}
      permissionKeyCode="Farm"
      routes={{
        newPath:  ()  =>  farmsRoute.new.build(),
        showPath: (id) => farmsRoute.show.build({id}),
        editPath: (id) => farmsRoute.edit.build({id})
      }}
      tableProps={{
        isLoading,
        rows,
        total,
        handleFetch,
        onDelete,
        schema: farmSchema,
        actions: ['show', 'edit', 'delete'],
        permissionKeyCode: 'Farm',
        filterProps: {
          columns: farmSchema.filterColumns
        }
      }}
    />
  );
}

const mapStateToProps = state => ({
  isLoading: state.farms.listIsLoading,
  rows: state.farms.data,
  total: state.farms.totalData,
});

export default connect(mapStateToProps)(List);